module.exports = __webpack_public_path__ + "img/中国旅游报_01.6dab78a3.jpg";